export default __webpack_public_path__ + "static/media/business-step.edf4ddcf.webp";